// Bottom edge (page px) of the frozen top chrome — from each bar's sticky `top`, not its live
// position, so the value never changes while scrolling (bars under it stay put).
export function topChromeBottom() {
    const bd = document.body;
    const Z = bd && bd.offsetWidth ? (bd.getBoundingClientRect().width / bd.offsetWidth) || 1 : 1;
    const bars = [];
    document.querySelectorAll('header,[data-testid="app-tabs-bar"],[data-testid$="-subnav"],[class*="fixed"]').forEach((node) => {
        const s = window.getComputedStyle(node);
        const r = node.getBoundingClientRect();
        if (!r.height || r.width < 300 || r.height > window.innerHeight * 0.5) return;
        if (s.position === "sticky") bars.push({ top: parseFloat(s.top) || 0, h: r.height / Z });
        else if (s.position === "fixed" && r.top <= 2 && r.height > 24) bars.push({ top: 0, h: r.bottom / Z });
    });
    let hb = 0, grew = true;
    while (grew) { grew = false; bars.forEach((b) => { if (b.top <= hb + 2 && b.top + b.h > hb + 1) { hb = b.top + b.h; grew = true; } }); }
    return Math.round(hb);
}
